import { render, staticRenderFns } from "./OrderNotes.vue?vue&type=template&id=ea7bc928&"
import script from "./OrderNotes.vue?vue&type=script&lang=js&"
export * from "./OrderNotes.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports